import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useParams } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import { getSingleDeveloperRequest } from "store/actions";
import Loader from "components/shared/Loader";

const ShowDeveloperRequest = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { formatMessage } = useIntl();
  const { loading, singleDeveloperRequest } = useSelector(
    (state) => state.developerRequests
  );

  useEffect(() => {
    dispatch(getSingleDeveloperRequest(id));
  }, [dispatch, id]);

  if (loading) return <Loader />;

  return (
    <div className="acc-form">
      <div className="card job-details">
        <div className="card-head">
          <h4>
            <FormattedMessage id={"showContact"} />
          </h4>
        </div>
        <div className="card-body table-details--">
          <div className="table-responsive">
            <table className="table table-bordered">
              <tbody>
                <tr>
                  <td>
                    <FormattedMessage id={"name"} />
                  </td>
                  <td>{singleDeveloperRequest?.fullName} </td>
                </tr>

                <tr>
                  <td>
                    <FormattedMessage id={"phone"} />
                  </td>
                  <td>{singleDeveloperRequest?.phone}</td>
                </tr>
                <tr>
                  <td>
                    <FormattedMessage id={"email"} />
                  </td>
                  <td>{singleDeveloperRequest?.email} </td>
                </tr>

                <tr>
                  <td>
                    <FormattedMessage id={"city"} />
                  </td>
                  <td>{singleDeveloperRequest?.city} </td>
                </tr>

                <tr>
                  <td>
                    <FormattedMessage id={"currentUsage"} />
                  </td>
                  <td>
                    {formatMessage({
                      id: singleDeveloperRequest?.currentUsage || "fallback",
                    })}
                  </td>
                </tr>
                {singleDeveloperRequest?.typeOfDevelopment && (
                  <tr>
                    <td>
                      <FormattedMessage id={"typeOfDevelopment"} />
                    </td>
                    <td>
                      {formatMessage({
                        id:
                          singleDeveloperRequest?.typeOfDevelopment ||
                          "fallback",
                      })}
                    </td>
                  </tr>
                )}
                {singleDeveloperRequest?.instrumentImage && (
                  <tr>
                    <td>
                      <FormattedMessage id={"instrumentImage"} />
                    </td>
                    <td>
                      <NavLink
                        to={singleDeveloperRequest?.instrumentImage}
                        target="_blank"
                      >
                        <img
                          src={singleDeveloperRequest?.instrumentImage}
                          alt=""
                        />
                      </NavLink>
                    </td>
                  </tr>
                )}
                {singleDeveloperRequest?.landImage && (
                  <tr>
                    <td>
                      <FormattedMessage id={"landImage"} />
                    </td>
                    <td>
                      <NavLink
                        to={singleDeveloperRequest?.landImage}
                        target="_blank"
                      >
                        <img src={singleDeveloperRequest?.landImage} alt="" />
                      </NavLink>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShowDeveloperRequest;
